'use client';

import { useEffect } from 'react';

import { useSetNearMeMapContext } from '@/src/lib/hooks';

type Props = {
  upgradeSlug: string;
  areaResourceId: string;
};

// Seeds the near-me area + upgrade slug for the persistent SearchMapIsland (the
// rewritten single-segment path can't supply them). Clears on unmount.
export function NearMeContextHydrator({ upgradeSlug, areaResourceId }: Props) {
  const setNearMeMapContext = useSetNearMeMapContext();

  useEffect(() => {
    setNearMeMapContext({ upgradeSlug, areaResourceId });
    return () => setNearMeMapContext(null);
  }, [upgradeSlug, areaResourceId, setNearMeMapContext]);

  return null;
}
